module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "panel-title big-title"
  }, [_vm._v("\n            Rapport de match\n        ")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.current) ? _c('div', {
    staticClass: "panel-content"
  }, [(_vm.current) ? _c('mrDetailedHeader', {
    attrs: {
      "actions": false,
      "match": _vm.current
    }
  }) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._v("\n                Actions:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('playerReportViewer', {
    attrs: {
      "match_report": _vm.current
    }
  })], 1), _vm._v(" "), (_vm.current.home_report.star_report.length > 0 || _vm.current.visitor_report.star_report.length > 0) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_vm._v("\n                    Actions des champions:\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('starReportViewer', {
    attrs: {
      "match_report": _vm.current
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('commentPanel', {
    attrs: {
      "entity_type": _vm.mrContentType.id,
      "entity_id": _vm.id
    }
  }), _vm._v(" "), _c('br')], 1) : _c('div', [_c('spinner')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c58a230"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/match-reports/mr-detail.vue
// module id = 751
// module chunks = 0